import { render, staticRenderFns } from "./GlobalMessageModal.vue?vue&type=template&id=6541ceec&scoped=true"
import script from "./GlobalMessageModal.vue?vue&type=script&lang=js"
export * from "./GlobalMessageModal.vue?vue&type=script&lang=js"
import style0 from "./GlobalMessageModal.vue?vue&type=style&index=0&id=6541ceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541ceec",
  null
  
)

export default component.exports